module.exports = __webpack_public_path__ + "static/media/trimex_Marfil.c0029313.png";